/**
 * eBoutique API
 * eBoutique API
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import {ApproveAndDeleteServicerTransferSummary} from './approveAndDeleteServicerTransferSummary';


export class ApproveAndDeleteServicerTransferSummaryList extends Array<ApproveAndDeleteServicerTransferSummary> {
}
